<script setup>
import DefaultLayout from '@frontJs/layouts/DefaultLayout.vue';
import { Head } from '@inertiajs/vue3';

defineOptions({ layout: DefaultLayout });
</script>

<template>
    <Head>
        <title>Datakepler</title>
    </Head>
</template>
